import styled from 'styled-components'
import SearchInput from 'components/SearchInput'
import { breakpoints } from '../helpers/utils'

const { mobile } = breakpoints

/** Matches `AdminModeBar` root height in @hssoft/design-system-shared-lib */
export const ADMIN_MODE_BAR_HEIGHT_PX = 37

/* fixed so it stays pinned above the (also fixed) AppHeader while scrolling;
   z-index one step above StyledHeaderWrapper's 17 in components/AppHeader/styled.js */
export const StyledAdminModeBarWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 18;
`

export const StyledCompareBtn = styled.div`
width: 100%;
height: 35px;
background: white;
color: gray;
padding-left: 5px;
font-size: 14px;
border: none;
margin-left: 10px;
min-width: 160px;
display: flex;
position: relative;
justify-content: space-between;
align-items: center;
border-radius: 5px;
border: 1px solid #CDCDCD;
padding-right: 15px;
background-color: white;
color: #434343;
box-shadow: ${({ simpleArrow }) => simpleArrow ? 'null' : '0px 0px 7px 0 rgba(0, 0, 0, 0.15)' };
transition: box-shadow ease 0.2s;
@media (max-width: 1200px) {
	min-width: 132px;
}
@media (max-width: 768px) {
	min-width: 40px;
}
@media (max-width: 767px) {
	padding-right: 0px;
}
& span {
	font-size: 14px;
	font-weight: ${({ smallText }) => smallText ? '400' : '500' };
	margin-right: ${({ smallText }) => smallText ? '11px' : '0px' };
	@media (max-width: 1200px) {
		font-size: 12px;
	}
}
&:hover{
	cursor: pointer;
	box-shadow: 0px 0px 7px 0 rgba(0, 0, 0, 0.15);
}

& .compare{
	font-size: 14px;
	font-weight: 500;
	@media (max-width: 1200px) {
		font-size: 12px;
	}
	&_today{
		color: #4A90E2;
		margin: 0 14px;
	}
	&_width{
		color: #F2874F;
		margin: 0 10px 0 0;
	}
}

& .scales_icon{
	& .comp_scales_icon{
		display: block;
	}
	& .leptop_scales_icon{
		display: none;
	}
	& .phone_scales_icon{
		display: none;
	}
	@media (max-width: 1200px){
		& .comp_scales_icon{
			display: none;
		}
		& .leptop_scales_icon{
			display: block;
		}
		& .phone_scales_icon{
			display: none;
		}
	}
	@media (max-width: 768px){
		& .comp_scales_icon{
			display: none;
		}
		& .leptop_scales_icon{
			display: none;
		}
		& .phone_scales_icon{
			display: block;
		}
	}
}

& .down_arrow_branch{
	transform: ${({ simpleArrow }) => simpleArrow ? 'null' : 'rotate(180deg)' };
	transition: transform ease 0.2s;
}
`

export const StyledHeaderContent = styled.div`
&>h3 {
		font-size: 36px;
		font-weight: 600;
		color: #434343;
		margin-bottom: 10px;
		@media (max-width: 1200px) {
			font-size: 28px;
			margin-bottom: 15px;
		}
		@media (max-width: 767px) {
			font-size: 36px;
			margin-bottom: 10px;
		}
		@media (max-width: 576px) {
			font-size: 29px;
		}
		@media (max-width: 400px) {
			font-size: 25px;
		}
		@media (max-width: 350px) {
			font-size: 22px;
		}
}
& span.header_text {
		color: #8DDBCD;
		font-size: 18px;
		font-weight: 600;
		position: relative;
		& .all_regions{
			display: flex;
			align-items: center;
			cursor: pointer;
			& svg {
				transition: transform ease 0.2s;
				transform: ${props => props.modalVisible ? 'rotate(180deg)' : 'none'}; 
			}
		}
		& .length{
			color: #CDCDCD;
			margin-left: 10px;
		}
		@media (max-width: 576px) {
			font-size: 15px;
		}
		@media (max-width: 400px) {
			font-size: 13px;
		}
		@media (max-width: 350px) {
			font-size: 11px;
		}
}
`

export const LoadingWrapper = styled.div`
position: absolute;
top: 0;
left: 0;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 100%;
`

export const StyledSearchInput = styled(SearchInput)`

`

export const Wrapper = styled.div`
padding-top: calc(70px + var(--admin-bar-height, 0px));
background-color: #f9f9f9;
min-height: calc(100vh - var(--admin-bar-height, 0px));
@media (${mobile}) {
		grid-template-columns: 1fr;
}
@media(max-width: 1200px) and (min-width: 768px){
	.container{
		width: 752px;
	}
}
@media (max-height: 610px) {
	padding-top: calc(49px + var(--admin-bar-height, 0px));
}
@media (max-width: 768px) and (max-height: 610px) {
	padding-top: calc(16px + var(--admin-bar-height, 0px));
}
@media (max-width: 576px) and (max-height: 610px) {
	padding-top: calc(20px + var(--admin-bar-height, 0px));
}
@media (max-width: 400px) and (max-height: 610px) {
	padding-top: calc(27px + var(--admin-bar-height, 0px));
}
& .close {
	width: 10px;
		height: 10px;
		&:before, &:after {
				position: absolute;
				content: ' ';
				height: 10px;
				width: 2px;
				background-color: #3e4c57;
		}
		&:before {
				transform: rotate(45deg);
		}
		&:after {
				transform: rotate(-45deg)
		}
		&_sidebar {
				display: none;
		}
		@media (${mobile}) {
				&_sidebar {
						display: block;
						position: fixed;
						z-index: 99999;
						right: 17px;
						top: 27px;
						&:after, &:before {
								height: 20px;
						}
						&:hover {
								cursor: pointer;
						}
				}
		}
}
`
